require('../proposals/efficient-64-bit-arithmetic');
require('../proposals/string-at');
require('../proposals/url');

module.exports = require('./1');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/stage/0.js
// module id = sLYn
// module chunks = 2